"use client";

import { Checkbox } from "@/components/ui/checkbox";

const OPTIONS = [
  {
    value: "shared",
    label: "Public (visible to everyone in your organization)",
  },
  {
    value: "private",
    label: "Private (only visible to you, members, and admin)",
  },
] as const;

export type AccessLevel = (typeof OPTIONS)[number]["value"];

interface AccessLevelFieldProps {
  value: AccessLevel;
  onChange: (value: AccessLevel) => void;
}

export function AccessLevelField({ value, onChange }: AccessLevelFieldProps) {
  return (
    <div
      role="radiogroup"
      aria-label="Access level"
      className="flex flex-col gap-1 mt-0.5"
    >
      {OPTIONS.map((opt) => (
        <div key={opt.value} className="flex items-start gap-2.5">
          <Checkbox
            className="mt-0.5 shrink-0"
            aria-label={opt.label}
            checked={value === opt.value}
            onChange={(checked) => {
              if (checked) onChange(opt.value);
            }}
          />
          <span className="text-sm font-medium leading-5 text-heading">
            {opt.label}
          </span>
        </div>
      ))}
    </div>
  );
}
